import useBracketStore from '@/stores/useBracketStore'
import PoolGrid from './PoolGrid'
import SundayMiniBracket from './SundayMiniBracket'

/**
 * Top-level renderer for pool_then_sunday brackets. Side-by-side pool grids
 * on desktop, stacked on mobile, with the Sunday mini-bracket below.
 *
 * Fans pick winners only. Head-to-head resolves most ties; a circular tie
 * at seeds 1-4 surfaces an inline TiebreakerPrompt inside the affected pool.
 * Sunday matchups appear once each pool's seeding is locked.
 */
export default function PoolPlayRenderer() {
  const poolStructure = useBracketStore(s => s.poolStructure)

  if (!poolStructure) {
    return (
      <div className="px-4 py-12 text-center text-muted-foreground">
        Pool structure not yet available.
      </div>
    )
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-4 space-y-4">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {poolStructure.pools.map(pool => (
          <PoolGrid key={pool.pool_id} pool={pool} />
        ))}
      </div>
      <SundayMiniBracket />
    </div>
  )
}
